import { memo, useCallback, useMemo } from "react";
import Navigator from "./components/Navigator";
import { Routes } from "const";
import { InformationIcon, InvestIcon, PortIcon, BriefcaseIcon, ResearchIcon } from "components/CustomIcon";
import { useSelector } from "react-redux";
import { MasterSelector } from "redux/selector";

function PwmNavigator({ navigate }) {
  const hideFundNavigation = useSelector(MasterSelector.hideFundNavigation);
  const menus = useMemo(
    () => [
      {
        key: "portfolio",
        label: "Port",
        icon: <PortIcon />,
        menuActiveRegex: [/^\/ultra-high\/portfolio/i, /^\/ultra-high\/model-portfolio/i],
      },
      {
        key: "investment",
        label: "Invest",
        icon: <InvestIcon />,
        menuActiveRegex: [
          /^\/ultra-high\/investment/i,
          /^\/primary\/?/i,
          /^\/secondary\/?/i,
          /^\/histories/i,
          /^\/structure-note/i,
          /^\/perpetual-bond/i,
          /^\/lombard-loan/i,
          new RegExp(`^${Routes.UltraHigh.BuySellSwitching.Buy}(/\\w+)?`, "i"),
          new RegExp(`^${Routes.UltraHigh.BuySellSwitching.Sell}(/\\w+)?`, "i"),
          new RegExp(`^${Routes.UltraHigh.BuySellSwitching.Switch}(/\\w+)?`, "i"),
          new RegExp(`^${Routes.UltraHigh.BuySellSwitching.Transaction}(/\\w+)?`, "i"),
        ],
      },
      hideFundNavigation ? null : {
        key: "fund",
        label: "Fund",
        icon: <BriefcaseIcon />,
        menuActiveRegex: [/\/ultra-high\/fund/i],
      },
      {
        key: "research",
        label: "Research",
        icon: <ResearchIcon />,
        menuActiveRegex: [/^\/research/i],
      },
      {
        key: "profile",
        label: "Profile",
        icon: <InformationIcon />,
        menuActiveRegex: [
          /^\/profile/i,
          new RegExp(`^${Routes.Register.CustomerInfo}`, "i"),
          new RegExp(`^${Routes.Register.RiskResult}`, "i"),
          new RegExp(`^${Routes.Register.Suitability}`, "i"),
          new RegExp(`^${Routes.Register.TermsConditions}`, "i"),
        ],
      },
    ].filter((menu) => menu !== null),
    [hideFundNavigation]
  );

  const onMenuClick = useCallback(
    (key) => {
      switch (key) {
        case "portfolio":
          navigate(Routes.UltraHigh.Portfolio.Home);
          break;
        case "investment":
          navigate(Routes.UltraHigh.Investment);
          break;
        case "fund":
          navigate(Routes.UltraHigh.Fund.Home);
          break;
        case "research":
          navigate(Routes.Research.ResearchList);
          break;
        case "profile":
          navigate(Routes.Profile);
          break;
        default:
          break;
      }
    },
    [navigate]
  );

  return <Navigator menus={menus} onMenuClick={onMenuClick} />;
}

export default memo(PwmNavigator);
